import adminTabsRegistry from "@/lib/tabs/registryAdminTabs";
import sharedTabsRegistry from "@/lib/tabs/registrySharedTabs";
import userTabsRegistry from "@/lib/tabs/registryUserTabs";

export * from "@/lib/tabs/registryAdminTabs";
export * from "@/lib/tabs/registrySharedTabs";
export * from "@/lib/tabs/registryUserTabs";

const registrySections = [
  adminTabsRegistry,
  userTabsRegistry,
  sharedTabsRegistry,
];

export default {
  dynamicTabResolvers: registrySections.flatMap(
    (section) => section.dynamicTabResolvers,
  ),
  staticTabBuilders: Object.assign(
    {},
    ...registrySections.map((section) => section.staticTabBuilders),
  ),
};
